import { create } from 'zustand'

interface ManageTagsStore {
  isManageTagsOpen: boolean
  openManageTags: () => void
  closeManageTags: () => void
}

export const useManageTags = create<ManageTagsStore>((set) => ({
  isManageTagsOpen: false,
  openManageTags: () => set(() => ({ isManageTagsOpen: true })),
  closeManageTags: () => set({ isManageTagsOpen: false }),
}))
